var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18705 0.813193C6.38231 1.00845 6.38231 1.32504 6.18705 1.5203L1.7073 6.00008L6.18705 10.4799C6.38231 10.6751 6.38231 10.9917 6.18705 11.1869C5.99179 11.3822 5.6752 11.3822 5.47994 11.1869L0.646631 6.35361C0.451364 6.15835 0.451364 5.84181 0.646631 5.64655L5.47994 0.813193C5.6752 0.617933 5.99179 0.617933 6.18705 0.813193Z",
    fill: "#A6A2A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.b054aa63de018e36be902e4fd89a1618.svg";
export { ForwardRef as ReactComponent };